import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";

const LINKS = [
  ["How it works", "#discover"],
  ["Features", "#features"],
  ["Who it's for", "#audiences"],
  ["Samples", "#samples"],
];

export const LogoMark = ({ size = 36 }) => (
  <span className="grid shrink-0 place-items-center rounded-[22%] bg-[var(--violet)]" style={{ width: size, height: size }} data-testid="brand-mark">
    <img src="/brand-icon.png" alt="" aria-hidden="true" style={{ width: size * 0.72, height: size * 0.72 }} />
  </span>
);

export const SignalBars = () => (
  <span className="signal-bars" aria-hidden="true" data-testid="brand-signal-bars"><i /><i /><i /></span>
);

export const Logo = ({ light = true }) => (
  <a href="/" className="flex items-center gap-2" data-testid="brand-logo">
    <LogoMark />
    <span className={`text-xl font-bold tracking-tight ${light ? "text-[var(--cream)]" : "text-[var(--ink)]"}`}>
      ondose<SignalBars />
    </span>
  </a>
);

export default function TopBar() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <header className="absolute inset-x-0 top-0 z-30 px-4 pt-4 sm:px-8">
      <div className="capsule mx-auto flex max-w-6xl items-center gap-4 rounded-2xl px-4 py-2.5">
        <Logo />
        <nav className="ml-auto hidden items-center gap-1 md:flex" aria-label="Primary">
          {LINKS.map(([l, h]) => (
            <a key={h} href={h} data-testid={`nav-${h.slice(1)}`} className="rounded-xl px-3.5 py-2 text-sm text-[var(--cream)]/75 transition-colors hover:bg-white/10 hover:text-[var(--cream)]">
              {l}
            </a>
          ))}
        </nav>
        <a href="#demo" data-testid="nav-request-demo" className="btn-orange ml-auto hidden items-center gap-1.5 rounded-xl px-4 py-2 text-sm font-semibold md:ml-2 md:inline-flex">
          Request a demo <ArrowUpRight size={16} />
        </a>
        <button className="ml-auto grid h-10 w-10 place-items-center rounded-xl text-[var(--cream)] md:hidden" aria-label={open ? "Close menu" : "Open menu"} data-testid="nav-burger" onClick={() => setOpen((o) => !o)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="capsule mx-auto mt-2 grid max-w-6xl gap-1 rounded-2xl p-3 md:hidden" data-testid="nav-sheet">
          {LINKS.map(([l, h], i) => (
            <a key={h} href={h} onClick={() => setOpen(false)} className="flex items-baseline gap-3 rounded-xl px-3 py-3 text-2xl text-[var(--cream)] font-serif-i">
              <span className="font-sans text-xs not-italic text-[var(--orange)]">0{i + 1}</span>
              {l}
            </a>
          ))}
          <a href="#demo" onClick={() => setOpen(false)} className="btn-orange mt-1 rounded-xl px-4 py-3 text-center font-semibold">Request a demo</a>
        </div>
      )}
    </header>
  );
}
